import getSteelCategoryName from '../../utils/getSteelCategoryName';
import type { ValueGetterParams } from 'ag-grid-community';
import type { OptionsType } from '../../types/options';
import type { Language, SelectOption, SteelCategory } from '../../types/common';

/**
 * steelCategoryからフィルタ用の文字列を生成する。
 * contextにcurrentLang, steelCategoryが存在する必要がある。
 * 解決できなかった場合はvalueをstringとして返す。
 * @param params [ValueGetterParams]
 * @returns string
 */
const steelCategoryFilterValueGetter = (params: ValueGetterParams) => {
  const value: SteelCategory | SteelCategory[] = params.getValue('steelCategory');
  const steelCategoryCodes: SteelCategory[] = Array.isArray(value) ? value : [value];
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const steelCategory: OptionsType<SteelCategory>[] | undefined = params.context?.steelCategory;
  // 分類コードの配列を分類名の配列にマップする。マッチするものが見つからなかったらコードのままにする。
  const steelCategoryNames: string[] = steelCategoryCodes.map((code) => {
    const steelCategoryName: string = getSteelCategoryName(code, steelCategory, currentLang.value);
    return steelCategoryName;
  });
  const filterValue: string = steelCategoryNames.join(', ');
  return filterValue;
};

export default steelCategoryFilterValueGetter;
